<template>
    <div>ok</div>
  </template>
  
  <script>  
  export default {
    props: ['estado', 'cidade'],
    mounted() {
        console.log(`Exibindo veículos para ${this.estado} / ${this.cidade}`);
        // Aqui você pode buscar os anúncios específicos para o estado/cidade
    },
  };
  </script>
  
  <style scoped>
  </style>
  